const baseUrl = process.env.NODE_ENV === "development" ? "http://localhost:4321/" : "https://final-project-teacher-app.herokuapp.com/";

const clientId = '7633690609-nm7dhj6md96naeal4uga22iof0dv4rlr.apps.googleusercontent.com';

export { baseUrl, clientId };
